import React, { useRef, useState, useEffect, useMemo} from 'react';
import { motion, useScroll, useTransform, useSpring} from 'framer-motion';
import catedral from "./assets/catedral.svg";
import banquete from "./assets/banquete.svg";
import ceremonia from "./assets/ceremonia.svg";
import gmaps from "./assets/gmaps.png"
import mapaChico from "./assets/mapa_elchico.jpg"


export default function MapPath() {

  const mapRef = useRef(null);
      const { scrollYProgress } = useScroll({
      target: mapRef,
      offset: ["start center", "end center"]
    });

  const pathLength = useTransform(scrollYProgress, [0, 0.8], [0, 1]);

  // B) Aparición de la Tarjeta Iglesia (Punto A - Inicio)
  // Aparece rápido entre el 5% y el 20% del scroll
  const churchOpacity = useTransform(scrollYProgress, [0.05, 0.25], [0, 1]);
  const churchY = useTransform(scrollYProgress, [0.05, 0.25], [20, 0]);

  // C) Aparición de la Tarjeta Recepción (Punto B - Final)
  // Aparece hacia el final, entre el 70% y el 90% del scroll
  const venueOpacity = useTransform(scrollYProgress, [0.6, 0.75], [0, 1]);
  const venueY = useTransform(scrollYProgress, [0.6, 0.75], [20, 0]);

  // Variantes para los marcadores (los puntitos en el mapa)
  const markerVariants = {
    hidden: { scale: 0, opacity: 0 },
    visible: { scale: 1, opacity: 1, transition: { type: "spring" } }
  };

  return (
    <div className="cont-scroll-mapa" ref={mapRef}>
        <div className="map-background" style={{ backgroundImage: `url(${mapaChico})` }} />

        <motion.div className="card-parroquia" style={{ opacity: churchOpacity, y: churchY }}>
          <p className="text-sm">PARROQUIA DE LA INMACULADA CONCEPCIÓN</p>
          <img src={catedral} alt="" className="icono-itinerario" />
              <p className="text-xs bold">CEREMONIA RELIGIOSA</p>
              <p className="text-xs bold">12:30 HORAS</p>
              <p className="text-sm tex t-cursiva texto-direccion">C. Morelos 12, Barrio de la Sierra, Mineral del Chico, Hgo.</p>
              <a className="btn-maps" target="_blank" href="https://www.google.com/maps/place/Iglesia+de+la+Inmaculada+Concepción,+C.+Morelos+12,+Barrio+de+la+Sierra,+42120+Mineral+del+Chico,+Hgo./@20.2154446,-98.7306269,16z/data=!4m6!3m5!1s0x85d10eb6ba4b21bf:0x93417c34ec000aa9!8m2!3d20.2154446!4d-98.7306269!16s%2Fg%2F11bxglk2_0?g_ep=Eg1tbF8yMDI2MDEwN18wIOC7DCoASAJQAQ%3D%3D">
                
                <img src={gmaps} alt="" style={{width: "10px"}}/>
                <p className="text-sm  blanco bold">Ver ubicación</p>
              </a>
        </motion.div>

       
        <motion.svg className='path-svg' width="100%" height="60%" viewBox="0 0 235 758" fill="none" xmlns="http://www.w3.org/2000/svg" >
            <motion.path d="M22.5 1.5C19.5 5.5 11 42.5 11 42.5C5.5 38 25.5 219 19 280C26.2 309.2 40 306.5 66 312.5C92.8333 314.5 132.2 337.6 75 414C49 443.6 82.5 486 102.5 503.5L191 597.5L229.5 699C232.167 704.833 235.4 718.2 227 725L198 752.5"  
            fill="none" 
            stroke="#29ADFF" 
            stroke-width="5"  
            style={{ pathLength }} />

            <motion.circle cx="12" cy="87" r="12" fill="#29ADFF"
                            variants={markerVariants}
                            initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.1 }}
                            style={{ opacity: churchOpacity, scale: churchOpacity }}/>

            <motion.circle cx="203" cy="746" r="12" fill="#29ADFF"
                            variants={markerVariants}
                            initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.1 }}
                            style={{ opacity: venueOpacity, scale: venueOpacity }}/>
        
        </motion.svg>

         <motion.div className="card-hotel bold" style={{ opacity: venueOpacity, y: venueY }}>
          <p className="text-sm">HOTEL EL PARAÍSO</p>
          <img src={ceremonia} alt="" className="icono-itinerario" />
          <p className="text-xs bold">CEREMONIA CIVIL</p>
          <p className="text-xs bold">16:00 HORAS</p>
          <img src={banquete} alt="" className="icono-itinerario" />
          <p className="text-xs bold">RECEPCIÓN Y BANQUETE</p>
          <p className="text-xs bold">18:00 HORAS</p>

          <p className="text-sm text-cursiva texto-direccion">Carretera Pachuca - Mineral del Chico Km.19, Centro, Mineral del Chico, Hgo.</p>
           <a className="btn-maps" target="_blank" href="https://maps.app.goo.gl/yFghnycFqxd5hBWX7">
                
                <img src={gmaps} alt="" style={{width: "10px"}}/>
                <p className="text-sm  blanco bold">Ver ubicación</p>
              </a>
        </motion.div>

    </div>
  )
}
